// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePickemContestCreateBody = {
  poolId: string;
  name: string;
  setup: {
    scoringFormat: "standard" | "confidence";
    picksRequiredMode: "all" | "count";
    picksRequiredCount?: number | null;
    pickBasis: "moneyline" | "spread";
    tiebreaker: "none" | "totalPoints";
    tiePolicy: "tieIsWin" | "tieIsLoss" | "tieIsVoid";
    winPoints: number;
    lossPoints: number;
    roundGrouping: "day" | "week";
    weekStartDay?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    endDateMode: "date" | "tbd";
  };
};

export type typePickemContestCreateOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { contestId: string; status: "created" | "existing" };
};

export type typePickemContestCreateOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickemContestCreateOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickemContestCreateOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPickemContestCreateBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    name: { type: "string", maxLength: 3000, minLength: 1 },
    setup: {
      type: "object",
      properties: {
        scoringFormat: { type: "string", enum: ["standard", "confidence"] },
        picksRequiredMode: { type: "string", enum: ["all", "count"] },
        picksRequiredCount: { oneOf: [{ type: "integer" }, { enum: [null] }] },
        pickBasis: { type: "string", enum: ["moneyline", "spread"] },
        tiebreaker: { type: "string", enum: ["none", "totalPoints"] },
        tiePolicy: {
          type: "string",
          enum: ["tieIsWin", "tieIsLoss", "tieIsVoid"],
        },
        winPoints: { type: "integer" },
        lossPoints: { type: "integer" },
        roundGrouping: { type: "string", enum: ["day", "week"] },
        weekStartDay: { oneOf: [{ type: "integer" }, { enum: [null] }] },
        startDate: {
          oneOf: [
            { type: "string", maxLength: 3000, minLength: 1 },
            { enum: [null] },
          ],
        },
        endDate: {
          oneOf: [
            { type: "string", maxLength: 3000, minLength: 1 },
            { enum: [null] },
          ],
        },
        endDateMode: { type: "string", enum: ["date", "tbd"] },
      },
      required: [
        "scoringFormat",
        "picksRequiredMode",
        "pickBasis",
        "tiebreaker",
        "tiePolicy",
        "winPoints",
        "lossPoints",
        "roundGrouping",
        "endDateMode",
      ],
    },
  },
  required: ["poolId", "name", "setup"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPickemContestCreate(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPickemContestCreateBody);
  }

  return async function postPickemContestCreate(
    payload: typePickemContestCreateBody,
  ): Promise<
    typePickemContestCreateOutput200 | typePickemContestCreateOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPickemContestCreate" failed before calling the network. #d8e2afedd86f`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#d8e2afedd86f" },
        },
        data: null,
      } as typePickemContestCreateOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pickem/contest-create`,
      httpMethod: "POST",
      options,
    })) as typePickemContestCreateOutput200 | typePickemContestCreateOutput400;
  };
}
